module.exports = __webpack_public_path__ + "img/NGC-3372.23a8a408.jpg";